import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import CalculatorSection from "@/components/CalculatorSection";
import MultiStepForm from "@/components/MultiStepForm";
import TrustSection from "@/components/TrustSection";
import FAQSection from "@/components/FAQSection";
import Footer from "@/components/Footer";

const LandingPage = () => {
  const [showForm, setShowForm] = useState(false);
  const [initialDebt, setInitialDebt] = useState(15000);

  const handleStartForm = (debtAmount) => {
    setInitialDebt(debtAmount || 15000);
    setShowForm(true);
    // Scroll to form
    setTimeout(() => {
      document.getElementById("form-section")?.scrollIntoView({ behavior: "smooth" });
    }, 100);
  };

  return (
    <div className="min-h-screen bg-white" data-testid="landing-page">
      <Header onGetStarted={() => handleStartForm(15000)} />
      
      {/* Add padding-top to account for fixed header */}
      <div className="pt-16 md:pt-20">
        <HeroSection onStartForm={handleStartForm} />
      
      </div>
      
      <div id="calculator-section">
        <CalculatorSection onStartForm={handleStartForm} />
      </div>
      
      <AnimatePresence>
        {showForm && (
          <motion.div
            id="form-section"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.5 }}
          >
            <MultiStepForm initialDebt={initialDebt} onClose={() => setShowForm(false)} />
          </motion.div>
        )}
      </AnimatePresence>
      
      <div id="trust-section">
        <TrustSection />
      </div>
      
      <div id="faq-section">
        <FAQSection />
      </div>
      
      <Footer />
    </div>
  );
};

export default LandingPage;
